/**
 * appSignTableModule
 * description：融合审签-app表格组件
 * author：Qian.qianchen
 */
'use strict';
angular.module('appSignTableModule', []).directive('appSignTable', [
    'editIsLock',
    '$state',
    'editingCenterAppService',
    '$window',
    '$q',
    'storageListenerService',
    'trsHttpService',
    'newMediaService',
    'editingCenterService',
    function(editIsLock, $state, editingCenterAppService, $window, $q, storageListenerService, trsHttpService, newMediaService, editingCenterService) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionSign/directive/appSignTable/appSignTable_tpl.html',
            scope: {
                productInfo: '=',
                selectedArray: '=',
                fromDate: '=',
                untilDate: '=',
                channelValue: '=',
                page: '='
            },
            link: function($scope, iElement, attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        // page: {
                        //     CURRPAGE: 1,
                        //     PAGESIZE: 20,
                        //     ITEMCOUNT: 0,
                        //     PAGECOUNT: 1,
                        // },
                        OprTime: '',
                        DocType: '',
                        editPath: editingCenterAppService.initEditPath(),
                    };
                    $scope.data = {
                        tableData: [],
                        channelData: [],
                        selectedChannel: [],
                        selectedChannelIds: '',
                    };
                    $scope.$on('refresh', function() {
                        // $scope.status.page.PAGESIZE = 9;
                        initData();
                    });
                    listenStorage();
                }

                /**
                 * [initData description] 数据初始化
                 * @return {[type]} [description]
                 */
                function initData() {
                    requestData().then(function() {
                        // getAllChannels();
                        requestListImg();
                        newMediaService.getReviseInfo($scope.data.items);
                        if ($scope.data.items.length) {
                            editingCenterService.queryVerifyDoc($scope.data.items);
                        }
                    });
                }

                /**
                 * [listenStorage description]监听本地缓存
                 * @return {[promise]} [description] promise
                 */
                function listenStorage() {
                    storageListenerService.listenApp(function() {
                        initData();
                        storageListenerService.removeListener('app');
                    }, $scope);
                }

                /**
                 * [requestData description] 表格数据请求
                 * @return {[type]} [description]
                 */
                function requestData() {
                    var deffer = $q.defer();
                    $scope.status.requestSuccess = false;
                    var params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'queryFusionDocumentsInShenQian',
                        // SiteId: $scope.productInfo.SITEID,
                        CurrPage: $scope.page.CURRPAGE,
                        PageSize: $scope.page.PAGESIZE,
                        OprTime: $scope.status.OprTime,
                        // DocType: $scope.status.DocType,
                        OprTimeStart: angular.isDefined($scope.fromDate) ? $scope.fromDate : '',
                        OprTimeEnd: angular.isDefined($scope.untilDate) ? $scope.untilDate : '',
                        // CHANNELID: ''
                        MediaTypes: '1',
                        SiteId: $scope.$parent.data.channelValue,
                        isPass: $scope.$parent.status.isPass,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.tableData = data.DATA;
                        $scope.data.items = data.DATA;
                        if ($scope.data.items.length) {
                            editingCenterService.queryVerifyDoc($scope.data.items).then(function(data) {
                                $scope.data.filterReviseItem = $scope.data.items.filter((item) => item.DOCMODIFYSTATUSNAME !== '待修订' && item.verifyDocIsCanOper);
                            });
                        }
                        $scope.data.itemCount = data.PAGER.ITEMCOUNT;
                        // $scope.page = Object.assign({}, data.PAGER); // 切换渠道改变不了分页总数
                        $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                        $scope.page.CURRPAGE = data.PAGER.CURRPAGE;
                        $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                        $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                        $scope.selectedArray = [];
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }

                /**
                 * [requestListImg description]
                 * @return  {[type]}  [return description]
                 */
                function requestListImg() {
                    var defer = $q.defer();
                    if (!$scope.data.tableData || $scope.data.tableData.length < 1) {
                        defer.resolve([]);
                    } else {
                        var params = {
                            serviceid: 'mlf_myrelease',
                            methodname: 'queryAllImgLogo',
                            metadataids: $scope.data.tableData.map((item, index) => item.METADATAID).join(','),
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            $scope.data.tableData.forEach((item, index) => {
                                item.ALLIMG = data[item.METADATAID];
                            });
                            defer.resolve(data);
                        });
                    }
                    return defer.promise;
                }

                /**
                 * [getAllChannels description] 获取所有栏目列表
                 * @return {[type]} [description]
                 */
                function getAllChannels() {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'getAllChannelsOfShenQian',
                        webSiteId: $scope.productInfo.SITEID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.channelData = data;
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }

                /**
                 * [hasEditRight description] 判断用户是否有稿件编辑权限
                 * @param  {[type]}  item [description] 稿件
                 * @return {Boolean}      [description]
                 */
                function hasEditRight(item) {
                    var defer = $q.defer();
                    var params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'checkUserHasChannelDaiShenEditRight',
                        mediaType: 1,
                        objectId: item.METADATAID,
                        currChannleId: item.CHANNELID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                }

                /**
                 * [selectChannel description] 栏目选择后重新请求数据
                 * @return {[type]} [description]
                 */
                $scope.selectChannel = function() {
                    $scope.data.selectedChannelIds = $scope.data.selectedChannel
                        .map(function(item) {
                            return item.CHANNELID;
                        })
                        .join(',');
                    initData();
                };

                /**
                 * [selectItem description] 稿件选择/取消选择
                 * @param  {[type]} item [description] 稿件
                 * @return {[type]}      [description]
                 */
                $scope.selectItem = function(item) {
                    if ($scope.isChecked(item)) {
                        $scope.selectedArray = $scope.selectedArray.filter(function(_item, index) {
                            return item.METADATAID != _item.METADATAID;
                        });
                        // $scope.selectedProduct = $scope.productInfo.SITEID;
                    } else {
                        $scope.selectedArray.push(item);
                    }
                };

                /**
                 * [isChecked description] 判断稿件是否选中
                 * @param  {[type]}  item [description] 稿件
                 * @return {Boolean}      [description]
                 */
                $scope.isChecked = function(item) {
                    return $scope.selectedArray.some(function(_item, index) {
                        return item.METADATAID == _item.METADATAID;
                    });
                };

                /**
                 * [selectAll description] 全选/取消全选
                 * @return {[type]} [description]
                 */
                $scope.selectAll = function() {
                    if ($scope.selectedArray.length == $scope.data.filterReviseItem.length) {
                        $scope.selectedArray = [];
                    } else {
                        $scope.selectedArray = angular.copy($scope.data.filterReviseItem);
                    }
                };

                /**
                 * [isSelectTime description] 是否进行了时间筛选
                 * @return {Boolean} [description]
                 */
                $scope.isSelectTime = function() {
                    var res =
                        (angular.isUndefined($scope.fromDate) || $scope.fromDate == '') &&
                        (angular.isUndefined($scope.untilDate) || $scope.untilDate == '');
                    return res;
                };

                /**
                 * [showMore description] 加载更多
                 * @return {[type]} [description]
                 */
                // $scope.showMore = function() {
                //     if ($scope.status.OprTime != '') {
                //         $scope.status.page.PAGESIZE = 9;
                //     } else {
                //         $scope.status.page.PAGESIZE += 10;
                //     }
                //     $scope.status.OprTime = '';
                //     initData();
                // };

                /**
                 * [loadSpecialData description] 加载特殊时间条件数据
                 * @param  {[type]} oprTime [description] 时间条件（1天/3天）
                 * @return {[type]}         [description]
                 */
                $scope.loadSpecialData = function(oprTime) {
                    $scope.status.OprTime = oprTime;
                    $scope.page.PAGESIZE = 20;
                    initData();
                };

                /**
                 * [isLockEdit description] 编辑前请求解锁
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                $scope.isLockEdit = function(item) {
                    hasEditRight(item)
                        .then(function() {
                            return editIsLock.isLock(item, 1);
                        })
                        .then(function(data) {
                            var editPath = $scope.status.editPath[item.DOCTYPEID];
                            var editParams = {
                                appchannelid: item.CHANNELID,
                                appchnldocid: item.CHNLDOCID,
                                appmetadataid: item.METADATAID,
                                appsiteid: item.SITEID,
                                appplatform: 1,
                            };
                            var editUrl = $state.href(editPath, editParams);
                            if (data.ISLOCK == 'false') {
                                $window.open(editUrl);
                            } else {
                                editIsLock.checkUnlockPermissions(item, data).then(function() {
                                    $window.open(editUrl);
                                });
                            }
                        });
                };

                /**
                 * [appPreview description] app稿件预览
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.appPreview = function(item) {
                    storageListenerService.previewPageTurningStorage($scope.data.tableData, 'METADATAID,DOCTYPEID,CHNLDOCID', 'appPreview');
                    var params = {
                        appchannelid: item.CHANNELID,
                        appchnldocid: item.CHNLDOCID,
                        appsiteid: item.SITEID,
                        appmetadataid: item.METADATAID,
                        appplatform: 1,
                        appdoctype: item.DOCTYPEID,
                        isawaitrevise: item.DOCMODIFYSTATUSNAME === '待修订' ? 'isawaitrevise' : '',
                    };
                    var url = $state.href('appPreview', params);
                    window.open(url);
                };

                /**
                 * [isSecondReview description] 判断列表稿件是否为二次审核的稿件
                 * @param  {[type]}  item [description]
                 * @return {Boolean}      [description]
                 */
                $scope.isSecondReview = function(item) {
                    if (angular.isDefined(item.ISSECONDREVIEW) && item.ISSECONDREVIEW == '1') {
                        return true;
                    } else {
                        return false;
                    }
                };

                /**
                 * [showVersionTime description]查看流程版本操作日志
                 * @param  {[obj]} item [description]稿件具体信息
                 * @return {[type]}      [description]
                 */
                $scope.showVersionTime = function(item) {
                    editingCenterService.getVersionTime(item, false);
                };
            },
        };
    },
]);
